// extracted by mini-css-extract-plugin
export default {"nav":"Overview_nav__jrehS","item":"Overview_item__yJtwF","active":"Overview_active__5YlNs"};